import { X } from 'lucide-react'

interface LegalModalProps {
  title: string
  content: string
  onClose: () => void
}

export function LegalModal({ title, content, onClose }: LegalModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="absolute inset-0 bg-bg/85 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-2xl max-h-[85vh] card flex flex-col shadow-2xl">
        <div className="flex items-center justify-between gap-4 pb-4 border-b border-border">
          <h3 className="font-display text-2xl font-bold">{title}</h3>
          <button
            onClick={onClose}
            className="flex-shrink-0 h-8 w-8 rounded-lg flex items-center justify-center text-text-dim hover:text-text hover:bg-panel-elevated transition"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 mt-4 prose-legal">
          {content.split('\n').map((line, i) => {
            if (line.startsWith('## ')) {
              return (
                <h3 key={i} className="font-display text-xl font-bold mt-6 mb-2 text-text">
                  {line.replace('## ', '')}
                </h3>
              )
            }
            if (line.startsWith('# ')) {
              return (
                <h2 key={i} className="font-display text-2xl font-bold mb-4 text-brand">
                  {line.replace('# ', '')}
                </h2>
              )
            }
            if (line.startsWith('**') && line.endsWith('**')) {
              return (
                <p key={i} className="text-sm font-semibold text-text-dim mb-1">
                  {line.replace(/\*\*/g, '')}
                </p>
              )
            }
            if (line.startsWith('- ')) {
              return (
                <li key={i} className="text-sm text-text-dim ml-4 mb-1">
                  {line.replace('- ', '').replace(/\*\*(.*?)\*\*/g, '$1')}
                </li>
              )
            }
            if (line.startsWith('---')) {
              return <hr key={i} className="border-border my-4" />
            }
            if (line.startsWith('*') && line.endsWith('*')) {
              return (
                <p key={i} className="text-xs text-text-dim italic mt-4">
                  {line.replace(/\*/g, '')}
                </p>
              )
            }
            if (line.trim() === '') {
              return <div key={i} className="h-2" />
            }
            return (
              <p key={i} className="text-sm text-text-dim leading-relaxed mb-2">
                {line.replace(/\*\*(.*?)\*\*/g, '$1')}
              </p>
            )
          })}
        </div>
      </div>
    </div>
  )
}
